import type { DeferredPromise } from './deferredPromise.types';

export const createDeferredPromise = <T>(): DeferredPromise<T> => {
  let resolve: (value: T) => void;
  let reject: (reason?: unknown) => void;

  const promise = new Promise<T>((_resolve, _reject) => {
    resolve = _resolve;
    reject = _reject;
  });

  return {
    promise,
    reject: (reason?: unknown) => reject?.(reason),
    resolve: (value: T) => resolve?.(value),
  };
};
